import { Input, Button } from '@bancobarigui/barihaus';
import { MenuOutlined, CloseOutlined } from '@ant-design/icons';

interface EditableListItemProps {
  value: string;
  onChange: (value: string) => void;
  onRemove: () => void;
  dragHandleProps?: any;
  placeholder?: string;
  isDragging?: boolean;
}

export function EditableListItem({
  value,
  onChange,
  onRemove,
  dragHandleProps,
  placeholder = 'Digite o valor',
  isDragging = false,
}: EditableListItemProps) {
  return (
    <div
      className={`flex items-center gap-2 ${
        isDragging ? 'opacity-50 shadow-lg' : ''
      }`}
    >
      {dragHandleProps && (
        <div {...dragHandleProps} className="cursor-move">
          <MenuOutlined className="text-gray-400" />
        </div>
      )}
      <Input
        size="middle"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="flex-1"
      />
      <Button
        type="text"
        size="small"
        className="text-red-500 hover:bg-red-50 rounded-full"
        icon={<CloseOutlined />}
        onClick={onRemove}
        children={undefined}
      />
    </div>
  );
}
